import { Model } from '@/models/Model';

export class Material extends Model
{
  protected $name: string = 'Material';
  protected $endpoint: string = '/materials';
  protected $fillable: string[] = ['name', 'percentage'];

  public name?: string;
  public id?: string;
  public uuid?: string;
  public percentage?: number;
}
